import { rootApi } from '../rootApi';

export const lmsDashboardApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getLmsDashboardStatistics: builder.query({
            query: ({ year } = {}) => ({
                url: 'v1/LmsDashboard/GetStatistics',
                method: 'POST',
                body: year ? { year } : {}
            }),
            transformResponse: (response) => response?.data || null
        }),

        getLmsDashboardCalendar: builder.query({
            query: ({ year, month }) => ({
                url: 'v1/LmsDashboard/GetCalendar',
                method: 'POST',
                body: { year, month }
            }),
            transformResponse: (response) => (Array.isArray(response?.data) ? response.data : [])
        }),

        getLmsDashboardUpcomingTrainings: builder.query({
            query: ({ pageNumber, pageSize } = {}) => ({
                url: 'v1/LmsDashboard/GetUpcomingTrainings',
                method: 'POST',
                body: { pageNumber: pageNumber || 1, pageSize: pageSize || 10 }
            }),
            transformResponse: (response) => {
                if (response && response.data && Array.isArray(response.data.items)) {
                    return { items: response.data.items, totalCount: response.data.totalCount || 0 };
                }
                return { items: [], totalCount: 0 };
            }
        })
    }),
    overrideExisting: false
});

export const { useGetLmsDashboardStatisticsQuery, useGetLmsDashboardCalendarQuery, useGetLmsDashboardUpcomingTrainingsQuery } = lmsDashboardApi;
